export default {
	sundayFirst: false,
	days: [
		'Segunda-feira',
		'Terça-feira',
		'Quarta-feira',
		'Quinta-feira',
		'Sexta-feira',
		'Sábado',
		'Domingo',
	],
	daysShort: ['Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb', 'Dom'],
	monthNames: [
		'Janeiro',
		'Fevereiro',
		'Março',
		'Abril',
		'Maio',
		' Junho',
		'Julho',
		'Agosto',
		'Setembro',
		'Outubro',
		'Novembro',
		'Dezembro',
	],
	colors: {
		selected: '#d04312',
		inRange: '#fc561c',
		selectedText: '#fff',
		text: '#565a5c',
		inRangeBorder: '#fc561c',
	},
	texts: {
		apply: 'Ok',
		cancel: 'Cancelar',
	},
};



// WEBPACK FOOTER //
// ./src/assets/js/settings.airbnb.js